import { RadioButtonProps } from 'types';

const labelStyles = {
  common: 'text-sm text-content ml-4'
};

const inputStyles = {
  common: 'h-4 w-4 border-primary'
};

const RadioButton = ({
  isSelected,
  label,
  onChange,
  value,
  labelStyle,
  ...props
}: RadioButtonProps) => (
  <div className="flex items-center">
    <input
      type="radio"
      onChange={onChange}
      id={label}
      value={value}
      {...props}
      checked={isSelected}
      // need to change accent color to primary color
      className={`accent-purple-600 ${inputStyles.common}`}
    />
    <label htmlFor={label} className={`${labelStyles.common} ${labelStyle}`}>
      {label}
    </label>
  </div>
);

export default RadioButton;
